<div style="max-height: 45px; flex-basis:100%;  text-align: end;">
  <img style="max-width: 100%; height: 100%; max-height: 45px; cursor: pointer;" (click)="openPatchBg()" [src]="img" alt="">
</div>
